import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const store = {
  get token() { return localStorage.getItem("aj_token"); },
  set token(v) { v ? localStorage.setItem("aj_token", v) : localStorage.removeItem("aj_token"); },
  get caseToken() { return localStorage.getItem("aj_case"); },
  set caseToken(v) { v ? localStorage.setItem("aj_case", v) : localStorage.removeItem("aj_case"); },
  get visit() { return localStorage.getItem("aj_visit"); },
  set visit(v) { v ? localStorage.setItem("aj_visit", v) : localStorage.removeItem("aj_visit"); },
  get visitor() { return localStorage.getItem("aj_visitor"); },
  set visitor(v) { localStorage.setItem("aj_visitor", v); },
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  if (store.token) cfg.headers.Authorization = `Bearer ${store.token}`;
  if (store.caseToken) cfg.headers["X-Case-Token"] = store.caseToken;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function streamJoe(body, onChunk) {
  const headers = { "Content-Type": "application/json" };
  if (store.token) headers.Authorization = `Bearer ${store.token}`;
  if (store.caseToken) headers["X-Case-Token"] = store.caseToken;
  const res = await fetch(`${API}/case/joe`, { method: "POST", headers, body: JSON.stringify(body) });
  if (!res.ok || !res.body) throw new Error("Joe is unavailable right now.");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.replace(/^data: /, "");
      if (line === "[DONE]") return;
      try { onChunk(JSON.parse(line).t); } catch { /* partial */ }
    }
  }
}

export const money = (n) => (n === null || n === undefined || isNaN(n) ? "—" : `$${Math.round(Number(n)).toLocaleString()}`);
export const titleize = (s) => (s || "").toString().replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
export const shortDate = (s) => (s ? new Date(s).toLocaleDateString() : "—");
export const referralUrl = (code) => `${window.location.origin}/r/${code}`;
export const longReferralUrl = (code) => `${window.location.origin}/start?ref=${code}`;
